import type React from 'react';

const getDisplayName = <T>(WrappedComponent: React.ComponentType<T>) => {
  if (!WrappedComponent) {
    return 'Component';
  }

  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export { getDisplayName };
